import _get from 'lodash/get';
import _merge from 'lodash/merge';

function getDefaultHosts() {
    return {
        development: {
            gateway: '',
            pms: '',
            api: '',
            dilu_api: '',
            'banner-mis': '',
            'act-mis': '',
            'activation': '',
            depot: '',
            operations: '',
            dpc: '',
            'msgcenter-api': '',
            'supply-api': '',
            'm-transaction': '',
            'm-transaction-invoice': '',
            'm-transaction-rfc': '',
            'deal': '',
            'dragonstone': '',
            'm-transaction-supply': '',
            'workshop': ''
        },
        test: {
            gateway: '',
            pms: '',
            api: '',
            dilu_api: '',
            'banner-mis': '',
            'activation': '',
            'act-mis': '',
            'depot': '',
            operations: '',
            'msgcenter-api': '',
            'm-transaction-invoice': '',
            'm-transaction-supply': '',
            'm-transaction-rfc': '',
            'deal': '',
            'dragonstone': '',
            'supply-api': '',
            'workshop': ''
        },
        pre: {
            gateway: '//pre-dilu.didi-food.com',
            pms: '//pre-crm.didi-food.com',
            api: '//pre-crm.didi-food.com',
            dilu_api: '//pre-dilu.didi-food.com',
            'banner-mis': '//pre-act-api.didi-food.com',
            'activation': '//pre-activation.didi-food.com',
            'act-mis': '//pre-act-api.didi-food.com',
            depot: '//pre-crm.didi-food.com',
            'msgcenter-api': '//pre-act-api.didi-food.com',
            'm-transaction-invoice': '//pre-deal.didi-food.com',
            'm-transaction-rfc': '//pre-deal.didi-food.com',
            'm-transaction-supply': '//pre-deal.didi-food.com',
            'deal': '//pre-deal.didi-food.com',
            'home-conf': '//home-conf.didi-food.com',
            'workshop': '//pre-transaction-mis.didi-food.com'
        },
        production: {
            gateway: '//dilu.didi-food.com',
            pms: '//crm.didi-food.com',
            api: '//crm.didi-food.com',
            dilu_api: '//dilu.didi-food.com',
            'banner-mis': '//act-api.didi-food.com',
            'activation': '//activation.didi-food.com',
            'act-mis': '//act-api.didi-food.com',
            depot: '//crm.didi-food.com',
            operations: '//act-api.didi-food.com',
            'msgcenter-api': '//act-api.didi-food.com',
            'm-transaction-invoice': '//deal.didi-food.com',
            'm-transaction-rfc': '//deal.didi-food.com',
            'm-transaction-supply': '//deal.didi-food.com',
            'deal': '//deal.didi-food.com',
            'home-conf': '//home-conf.didi-food.com',
            'workshop': '//transaction-mis.didi-food.com'
        },
        sim: {
            gateway: '/dilu',
            pms: '/crm',
            api: '/crm',
            dilu_api: '/dilu',
            'banner-mis': '/act-api',
            'activation': '/activation',
            'act-mis': '/act-api',
            depot: '/crm',
            operations: '/act-api',
            'msgcenter-api': '/act-api',
            'm-transaction-invoice': '/deal',
            'm-transaction-rfc': '/deal',
            'm-transaction-supply': '/deal',
            'deal': '/deal',
            'home-conf': '/home-conf',
            'workshop': '/transaction-mis'
        }
    };
}

var Env;
(function (Env) {
    Env["DEV"] = "development";
    Env["TEST"] = "test";
    Env["PRE"] = "pre";
    Env["PRO"] = "production";
    Env["SIM"] = "sim";
})(Env || (Env = {}));
const isSimEnv = location.host.startsWith('sim');
const isLegacySimEnv = location.host.startsWith('rlab-sim');
const defaultHost = getDefaultHosts();
function getLegacyEnvDiluHost(envTag) {
    return `//rlab-sim${envTag}-dilu.rlab.sim.intra.xiaojukeji.com`;
}
function getHostConfig(env = Env.DEV, config = {}) {
    if (isSimEnv) {
        env = Env.SIM;
    }
    if (isLegacySimEnv) { // compatible with old simulation environment.
        const matches = location.host.match(/(\d+)/);
        return !matches ? defaultHost.sim : _merge(defaultHost.sim, {
            gateway: getLegacyEnvDiluHost(matches[0]),
            dilu_api: getLegacyEnvDiluHost(matches[0])
        });
    }
    const hostMap = _merge(defaultHost, config);
    return _get(hostMap, env, hostMap[Env.DEV]);
}
const GattaranHost = {
    getHostConfig
};

export { Env, GattaranHost as default, isLegacySimEnv, isSimEnv };
